export function dateFormat(time) {
    const date = new Date(time)
    let yil = date.getFullYear()
    let oy = (date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)
    let kun = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    let soat = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    let minut = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    return `${oy}-${kun}-${yil} ${soat}:${minut}`
}